import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const TypeSchedules = () => {
  return (
    <SettingsMetaData propertyName={"Type_Schedules"} viewPropertyName={"Type"} />
  );
};
export default TypeSchedules;